var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveAddButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1505 5.19444H6.51161V1.55556C6.51161 1.11378 6.14783 0.75 5.70605 0.75C5.26428 0.75 4.9005 1.11378 4.9005 1.55556V5.19444H1.26161C0.819835 5.19444 0.456055 5.55823 0.456055 6C0.456055 6.44177 0.819835 6.80556 1.26161 6.80556H4.9005V10.4444C4.9005 10.8862 5.26428 11.25 5.70605 11.25C6.14783 11.25 6.51161 10.8862 6.51161 10.4444V6.80556H10.1505C10.5923 6.80556 10.9561 6.44177 10.9561 6C10.9561 5.55822 10.5923 5.19444 10.1505 5.19444Z",
    fill: "#26875C",
    stroke: "#26875C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAddButton);
export default __webpack_public_path__ + "static/media/ActiveAddButton.ef22b481e6e2d4cddafc25347e4306a4.svg";
export { ForwardRef as ReactComponent };